jQuery($ => {
    class SearchToggle {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._trigger = this._element.find('.m-search-toggle__trigger-input');
        this._searchInput = this._element.find('.m-search-toggle__input input');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Utility functions
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleClickOutside = (e) => {
        const target = $(e.target);
        // Check if target is within this._element
        if (!target.closest(this._element).length) {
          this.handleClose(true);
        };
      }

      handleToggle(e) {
        if (e.target.checked) {
          this.handleOpen(true);
        } else {
          this.handleClose(true);
        }
      }

      handleOpen() {
        // If trigger is still unchecked, check it
        if (!this._trigger.prop('checked')) {
          this._trigger.prop('checked', true);
        }

        this._element.addClass('m-search-toggle--open');

        setTimeout(() => {
          $('body').on('click', this.handleClickOutside);
        }, 0);

        setTimeout(() => {
          this._searchInput.focus();
        }, 250);
      }

      handleClose() {
        this.unregisterClickOutside();
        this._element.removeClass('m-search-toggle--open');
        
        // If trigger is still checked, uncheck it
        if (this._trigger.prop('checked')) {
          this._trigger.prop('checked', false);
        }
      }

      unregisterClickOutside() {
        $('body').off('click', this.handleClickOutside);
      }

      handleFieldResize() {
        // If window width > 1024px
        // Resize the input field based on the input value
        if (window.innerWidth > 1024) {
          let width = this._searchInput.val().length * 10 + 130;

          if (width < 340) width = 340;
          if (width > 600) width = 600;

          this._element.css('--max-width', `${width}px`);
        }        
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._trigger.on('change', (e) => this.handleToggle(e));

        this._searchInput.on('keyup', (e) => {
          if (e.key === 'Escape') {
            this.handleClose(true);
          } else {
            this.handleFieldResize();
          }
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.search_toggle = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].search_toggle = new SearchToggle(_[i], opt);
        else
          ret = _[i].search_toggle[opt].apply(_[i].search_toggle, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-search-toggle').search_toggle();
});